/* assets/bouquets-pills.js
   Dawn-compatible: change hidden inputs, then trigger 'input' (facets.js listens to input).
   Uses event delegation because facets.js replaces the .sorting DOM during AJAX updates.
   FIX: After every AJAX re-render, sync active state on ALL pill containers (desktop + mobile).
*/
(function () {
  const TAG_PARAM = 'filter.p.tag';

  function getFacetsForm() {
    const desktop = document.getElementById('FacetFiltersForm');
    if (desktop) return desktop;
    const mobile = document.getElementById('FacetFiltersFormMobile');
    if (mobile) return mobile;
    return null;
  }

  function removeTagInputs(form) {
    form.querySelectorAll(`input[name="${TAG_PARAM}"]`).forEach((el) => el.remove());
  }

  function setTagInput(form, value) {
    removeTagInputs(form);
    if (!value) return;
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = TAG_PARAM;
    input.value = value;
    form.appendChild(input);
  }

  function triggerUpdate(form) {
    form.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /* ------------------------------------------------------------------
     FIX: getActiveTag() — read the currently active tag from the URL
     so we can keep pills in sync after AJAX navigation.
  ------------------------------------------------------------------ */
  function getActiveTagFromURL() {
    const params = new URLSearchParams(window.location.search);
    return params.get(TAG_PARAM) || null;
  }

  /* ------------------------------------------------------------------
     FIX: syncPillActiveStates()
     Called after every page load and every AJAX re-render.
     Marks the correct pill as is-active in every pills container
     on the page (desktop small-hide + mobile medium-hide, drawer empty div).
  ------------------------------------------------------------------ */
  function syncPillActiveStates() {
    const activeTag = getActiveTagFromURL();

    document.querySelectorAll('[data-bouquets-pills]').forEach((container) => {
      // Skip the empty drawer placeholder — it has no pill buttons
      const pills = container.querySelectorAll('.bouquets-pill');
      if (!pills.length) return;

      pills.forEach((pill) => {
        const clearBtn = pill.hasAttribute('data-pill-clear-tag');
        const tagValue = pill.getAttribute('data-pill-tag-value');

        if (clearBtn) {
          // "All" pill is active when no tag filter is active
          pill.classList.toggle('is-active', !activeTag);
          pill.setAttribute('aria-pressed', !activeTag ? 'true' : 'false');
        } else {
          const isActive = !!activeTag && tagValue === activeTag;
          pill.classList.toggle('is-active', isActive);
          pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }
      });
    });
  }

  /* ------------------------------------------------------------------
     FIX: Dawn's facets.js fires a custom event 'facets:updated'
     AND re-renders the section via fetch + innerHTML.
     We hook into both the custom event and MutationObserver to catch
     the re-render and re-sync active states.
  ------------------------------------------------------------------ */
  function observePillsContainers() {
    // Watch the product grid container — Dawn replaces it after filtering
    const gridContainer = document.getElementById('ProductGridContainer');
    if (!gridContainer) return;

    const observer = new MutationObserver(() => {
      syncPillActiveStates();
    });

    observer.observe(gridContainer, { childList: true, subtree: false });
  }

  /* ------------------------------------------------------------------
     Also watch the facets sidebar (aside#main-collection-filters)
     because Dawn re-renders it too, which replaces the pill containers.
  ------------------------------------------------------------------ */
  function observeFacetsContainer() {
    const aside = document.getElementById('main-collection-filters');
    if (!aside) return;

    const observer = new MutationObserver(() => {
      syncPillActiveStates();
    });

    observer.observe(aside, { childList: true, subtree: true });
  }

  /* Scroll affordance — hide fade when fully scrolled right */
function initScrollAffordance() {
  document.querySelectorAll('.bouquets-pills-scroll-wrap').forEach(function (wrap) {
    const scroller = wrap.querySelector('.bouquets-pills');
    if (!scroller) return;

    function check() {
      const scrollLeft = scroller.scrollLeft;
      const atStart = scrollLeft <= 4;
      const atEnd = scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 4;

      wrap.classList.toggle('scroll-left', !atStart);   // left fade when not at start
      wrap.classList.toggle('scroll-right', !atEnd);    // right fade when not at end
    }

    scroller.addEventListener('scroll', check, { passive: true });
    check();

    // Scroll active pill into view (e.g. when arriving via a tagged URL)
    const activePill = scroller.querySelector('.bouquets-pill.is-active');
    if (activePill) {
      // Small delay so layout is complete before measuring
      setTimeout(function () {
        activePill.scrollIntoView({ block: 'nearest', inline: 'start' });
        check(); // re-evaluate fades after scroll
      }, 100);
    }
  });
}

/* Default pill — activate "Just Because" if no tag is in the URL */
function activateDefaultPill() {
  const hasTag = new URLSearchParams(window.location.search).has(TAG_PARAM);
  if (hasTag) return; // user already has a filter active

  // Find pill with data-pill-tag-value matching "Everyday" (or label "Just Because")
  const defaultPill = document.querySelector(
    '[data-bouquets-pills] [data-pill-tag-value="Everyday"], ' +
    '[data-bouquets-pills] [data-pill-tag-value="everyday"]'
  );
  if (!defaultPill) return;

  // Set it active visually
  defaultPill.classList.add('is-active');
  defaultPill.setAttribute('aria-pressed', 'true');

  // Deactivate the "All" pill
  document.querySelectorAll('[data-pill-clear-tag]').forEach(function (p) {
    p.classList.remove('is-active');
    p.setAttribute('aria-pressed', 'false');
  });

  // Trigger the facet filter
  const form = getFacetsForm();
  if (!form) return;
  setTagInput(form, defaultPill.getAttribute('data-pill-tag-value'));
  triggerUpdate(form);
}

  /* ------------------------------------------------------------------
     Delegated click handler
  ------------------------------------------------------------------ */
  document.addEventListener('click', (e) => {
    const pillsRoot = e.target.closest('[data-bouquets-pills]');
    if (!pillsRoot) return;

    const clearBtn = e.target.closest('[data-pill-clear-tag]');
    const tagBtn = e.target.closest('[data-pill-tag-value]');
    if (!clearBtn && !tagBtn) return;

    e.preventDefault();

    const form = getFacetsForm();
    if (!form) return;

    if (clearBtn) {
      removeTagInputs(form);
      triggerUpdate(form);
      return;
    }

    const value = tagBtn.getAttribute('data-pill-tag-value') || '';
    setTagInput(form, value);
    triggerUpdate(form);
  });

  /* ------------------------------------------------------------------
     Init
  ------------------------------------------------------------------ */
  document.addEventListener('DOMContentLoaded', () => {
    syncPillActiveStates();
    observePillsContainers();
    observeFacetsContainer();
    initScrollAffordance();
    //activateDefaultPill(); // disabled due to issues with the sort filter
  });

  // Also handle Shopify section events (theme editor)
  document.addEventListener('shopify:section:load', syncPillActiveStates);
  document.addEventListener('shopify:section:reorder', syncPillActiveStates);
  document.addEventListener('shopify:section:select', syncPillActiveStates);

  // Handle browser back/forward (popstate = URL changed)
  window.addEventListener('popstate', syncPillActiveStates);

})();


(function attachMobileProxySort() {
  const proxy = document.getElementById('BouquetsSortByMobileProxy');
  if (!proxy) return;

  proxy.addEventListener('change', () => {
    const realSelect =
      document.getElementById('SortBy-mobile') ||
      document.querySelector('#FacetFiltersFormMobile select[name="sort_by"]') ||
      document.querySelector('#FacetFiltersForm select[name="sort_by"]');

    if (!realSelect) return;

    realSelect.value = proxy.value;

    const form = document.getElementById('FacetFiltersForm') || document.getElementById('FacetFiltersFormMobile');
    if (!form) return;
    form.dispatchEvent(new Event('input', { bubbles: true }));
  });

  const syncCount = () => {
    const src = document.getElementById('ProductCount') || document.getElementById('ProductCountDesktop');
    const dst = document.getElementById('BouquetsProductCountMobileProxy');
    if (src && dst) dst.innerHTML = src.innerHTML;
  };

  syncCount();
  document.addEventListener('shopify:section:load', syncCount);
  document.addEventListener('shopify:section:reorder', syncCount);
  document.addEventListener('shopify:section:select', syncCount);
})();